import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface NavigationButtonProps {
  displayText: string;
  navigationPath: string;
  icon?: string;
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({
  displayText,
  navigationPath,
  disabled = false,
  isLoading = false,
  onClick,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    // Validate path before navigating
    if (navigationPath.startsWith('/')) {
      navigate(navigationPath);
    } else {
      console.warn(`Invalid navigation path: ${navigationPath}`);
    }
  };

  return (
    <Button
      onClick={handleClick}
      disabled={disabled || isLoading}
      variant="outlined"
      color="primary"
      size="small"
      sx={{
        borderRadius: 3,
        textTransform: 'none',
        fontSize: '0.8rem',
        minHeight: 32,
        borderColor: (theme) =>
          theme.palette.mode === 'dark'
            ? 'rgba(255,255,255,0.2)'
            : 'rgba(0,0,0,0.2)',
        color: (theme) =>
          theme.palette.mode === 'dark'
            ? 'rgba(255,255,255,0.9)'
            : 'rgba(0,0,0,0.8)',
        '&:hover': {
          borderColor: (theme) =>
            theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.4)'
              : 'rgba(0,0,0,0.4)',
          backgroundColor: (theme) =>
            theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.1)'
              : 'rgba(0,0,0,0.05)',
        },
        '&:disabled': {
          borderColor: (theme) =>
            theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.1)'
              : 'rgba(0,0,0,0.1)',
          color: (theme) =>
            theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.3)'
              : 'rgba(0,0,0,0.3)',
        },
      }}
    >
      {isLoading ? 'Processing...' : displayText}
    </Button>
  );
};

export default NavigationButton;
